// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__2mZWl","items":"Contact_items__1YUDE"};